import CommerceService from "../../CommerceService"

const CommerceProduct = {
    formData(data) {
        let form = new FormData()
        for (let obj in data) {
            form.append(obj, data[obj])
        }
        return form
    },
    gets(r) {
        let url = '/products'
        if (r != undefined) {
            url = '/products?' + r
        }
        return CommerceService.get(url)
    },
}
export default CommerceProduct
